import classnames from 'classnames/bind'
import PropTypes from 'prop-types'

// Components

// Constants
import { isLiveMallClub } from '@/constants/systemType'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
const propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  name: PropTypes.string,
  checked: PropTypes.bool,
  isRound: PropTypes.bool,
}

const defaultProps = {
  onChange: () => {},
}

function Checkbox(props) {
  const { className, label, onChange, name, checked, isRound, ...restProps } = props

  return (
    <div className={cx('checkbox', className, { isLiveMallClub, isRound })} {...restProps}>
      <label className={cx('checkbox-wrapper')}>
        <input className={cx('checkbox-input')} type='checkbox' onChange={(event) => onChange(event)} name={name} checked={checked} />
        <div className={cx('checkbox-check')}>
          <div className={cx('checkbox-check-icon')} data-is-checked={checked} />
        </div>
        <span className={cx('checkbox-label')}>{label}</span>
      </label>
    </div>
  )
}

Checkbox.propTypes = propTypes
Checkbox.defaultProps = defaultProps

export default Checkbox
